/**
 * @generated SignedSource<<9d5877a7a4c31d5ee159bfb377473904>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type lockAnonymousMyLockQuery$variables = {
  accessToken: string;
};
export type lockAnonymousMyLockQuery$data = {
  readonly anonymousUtilizationGrant: {
    readonly " $fragmentSpreads": FragmentRefs<"AnonymousLockAccessFragment">;
  } | null | undefined;
};
export type lockAnonymousMyLockQuery = {
  response: lockAnonymousMyLockQuery$data;
  variables: lockAnonymousMyLockQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessToken"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accessToken",
    "variableName": "accessToken"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deactivatedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = [
  (v2/*:: as any*/)
],
v6 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "DateTime"
},
v7 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v8 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "String"
},
v9 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "DateTime"
},
v10 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v11 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Float"
},
v12 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "lockAnonymousMyLockQuery",
    "selections": [
      {
        "kind": "CatchField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "UtilizationGrant",
          "kind": "LinkedField",
          "name": "anonymousUtilizationGrant",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AnonymousLockAccessFragment"
            }
          ],
          "storageKey": null
        },
        "to": "NULL"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "lockAnonymousMyLockQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UtilizationGrant",
        "kind": "LinkedField",
        "name": "anonymousUtilizationGrant",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ty",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "permissions",
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LockReservation",
            "kind": "LinkedField",
            "name": "reservation",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startedAt",
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contentNote",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "note",
                "storageKey": null
              },
              {
                "alias": "lastUnlock",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "status": "UNLOCKED"
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": [
                      {
                        "field": "CREATED_AT",
                        "ordering": "DESC"
                      }
                    ]
                  },
                  {
                    "kind": "Literal",
                    "name": "pagination",
                    "value": {
                      "page": 0,
                      "pageSize": 1
                    }
                  }
                ],
                "concreteType": "UnlockRequestPage",
                "kind": "LinkedField",
                "name": "unlockRequests",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnlockRequest",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unlockedAt",
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "unlockRequests(filter:{\"status\":\"UNLOCKED\"},orderBy:[{\"field\":\"CREATED_AT\",\"ordering\":\"DESC\"}],pagination:{\"page\":0,\"pageSize\":1})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "subtype",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdByUserId",
                        "plural": false,
                        "selections": (v5/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "B2BlockReservationSubtype",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v5/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "B2ClockSession",
                        "kind": "LinkedField",
                        "name": "b2CLockSession",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rentalStartedAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentCost",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "finalAmount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "amountCollected",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "B2ClockReservationSubtype",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "frame",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "position",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "configuration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Hub",
                    "kind": "LinkedField",
                    "name": "hub",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HubMeta",
                        "kind": "LinkedField",
                        "name": "meta",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "services",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "street",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "city",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "postalCode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lat",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lng",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4ce423b2037cec293b4b3a5bdff525a5",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "anonymousUtilizationGrant": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "UtilizationGrant"
        },
        "anonymousUtilizationGrant.deactivatedAt": (v6/*:: as any*/),
        "anonymousUtilizationGrant.id": (v7/*:: as any*/),
        "anonymousUtilizationGrant.permissions": {
          "enumValues": [
            "END_RENTAL",
            "UNLOCK",
            "END_ON_OPEN"
          ],
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrantPermission"
        },
        "anonymousUtilizationGrant.reservation": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservation"
        },
        "anonymousUtilizationGrant.reservation.contentNote": (v8/*:: as any*/),
        "anonymousUtilizationGrant.reservation.createdAt": (v9/*:: as any*/),
        "anonymousUtilizationGrant.reservation.deactivatedAt": (v6/*:: as any*/),
        "anonymousUtilizationGrant.reservation.id": (v7/*:: as any*/),
        "anonymousUtilizationGrant.reservation.lastUnlock": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "UnlockRequestPage"
        },
        "anonymousUtilizationGrant.reservation.lastUnlock.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "UnlockRequest"
        },
        "anonymousUtilizationGrant.reservation.lastUnlock.nodes.createdAt": (v9/*:: as any*/),
        "anonymousUtilizationGrant.reservation.lastUnlock.nodes.unlockedAt": (v6/*:: as any*/),
        "anonymousUtilizationGrant.reservation.note": (v8/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Space"
        },
        "anonymousUtilizationGrant.reservation.space.configuration": {
          "enumValues": [
            "BACE_STOREFRONT_S",
            "BACE_STOREFRONT_M",
            "BACE_STOREFRONT_L",
            "BACE_STOREFRONT_XL",
            "BACE_STOREFRONT_2XL",
            "BACE_SATELLITE_SMALL_STANDARD",
            "BACE_SATELLITE_SMALL_SLIM",
            "BACE_SATELLITE_SMALL_EXTENDED",
            "BACE_SATELLITE_MEDIUM_STANDARD",
            "BACE_SATELLITE_MEDIUM_EXTENDED",
            "BACE_SATELLITE_LARGE_STANDARD",
            "BACE_SATELLITE_LARGE_EXTENDED",
            "BACE_CLATTERING_STANDARD",
            "BACE_TRUCK_HUB_STANDARD",
            "THALIA_RENZ_STANDARD_XS",
            "THALIA_RENZ_STANDARD_S",
            "THALIA_RENZ_STANDARD_M",
            "THALIA_RENZ_WIDE_S",
            "THALIA_RENZ_WIDE_M"
          ],
          "nullable": false,
          "plural": false,
          "type": "SpaceConfiguration"
        },
        "anonymousUtilizationGrant.reservation.space.frame": (v10/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Hub"
        },
        "anonymousUtilizationGrant.reservation.space.hub.id": (v7/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "anonymousUtilizationGrant.reservation.space.hub.meta.city": (v10/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.id": (v7/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.lat": (v11/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.lng": (v11/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.name": (v10/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.postalCode": (v10/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.meta.services": {
          "enumValues": [
            "INSTANT_BUY",
            "ONEDELIVERY",
            "CLICK_N_COLLECT",
            "RAFFLE",
            "LOCK_B2B",
            "LOCK_B2C",
            "SHOP_N_COLLECT"
          ],
          "nullable": false,
          "plural": true,
          "type": "HubService"
        },
        "anonymousUtilizationGrant.reservation.space.hub.meta.street": (v10/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.hub.status": {
          "enumValues": [
            "ONLINE",
            "OFFLINE"
          ],
          "nullable": false,
          "plural": false,
          "type": "HubStatus"
        },
        "anonymousUtilizationGrant.reservation.space.id": (v7/*:: as any*/),
        "anonymousUtilizationGrant.reservation.space.position": (v12/*:: as any*/),
        "anonymousUtilizationGrant.reservation.startedAt": (v9/*:: as any*/),
        "anonymousUtilizationGrant.reservation.subtype": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservationSubtype"
        },
        "anonymousUtilizationGrant.reservation.subtype.__typename": (v10/*:: as any*/),
        "anonymousUtilizationGrant.reservation.subtype.b2CLockSession": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "B2ClockSession"
        },
        "anonymousUtilizationGrant.reservation.subtype.b2CLockSession.amountCollected": (v12/*:: as any*/),
        "anonymousUtilizationGrant.reservation.subtype.b2CLockSession.currentCost": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Decimal"
        },
        "anonymousUtilizationGrant.reservation.subtype.b2CLockSession.finalAmount": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Int"
        },
        "anonymousUtilizationGrant.reservation.subtype.b2CLockSession.rentalStartedAt": (v6/*:: as any*/),
        "anonymousUtilizationGrant.reservation.subtype.createdByUserId": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "User"
        },
        "anonymousUtilizationGrant.reservation.subtype.createdByUserId.id": (v7/*:: as any*/),
        "anonymousUtilizationGrant.reservation.subtype.user": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "User"
        },
        "anonymousUtilizationGrant.reservation.subtype.user.id": (v7/*:: as any*/),
        "anonymousUtilizationGrant.ty": {
          "enumValues": [
            "USER",
            "ORGANIZATION",
            "ANONYMOUS"
          ],
          "nullable": false,
          "plural": false,
          "type": "LockGrantType"
        }
      }
    },
    "name": "lockAnonymousMyLockQuery",
    "operationKind": "query",
    "text": "query lockAnonymousMyLockQuery(\n  $accessToken: String!\n) {\n  anonymousUtilizationGrant(accessToken: $accessToken) {\n    ...AnonymousLockAccessFragment\n  }\n}\n\nfragment AnonymousLockAccessFragment on UtilizationGrant {\n  ...LockCardFragment\n  ...MyLocksTabsFragment\n  reservation {\n    space {\n      hub {\n        id\n      }\n    }\n  }\n}\n\nfragment LockCardFragment on UtilizationGrant {\n  id\n  ty\n  permissions\n  deactivatedAt\n  reservation {\n    id\n    startedAt\n    createdAt\n    deactivatedAt\n    contentNote\n    note\n    lastUnlock: unlockRequests(filter: {status: UNLOCKED}, orderBy: [{field: CREATED_AT, ordering: DESC}], pagination: {page: 0, pageSize: 1}) {\n      nodes {\n        unlockedAt\n        createdAt\n      }\n    }\n    subtype {\n      __typename\n      ... on B2BlockReservationSubtype {\n        createdByUserId {\n          id\n        }\n      }\n      ... on B2ClockReservationSubtype {\n        user {\n          id\n        }\n        b2CLockSession {\n          rentalStartedAt\n          currentCost\n          finalAmount\n          amountCollected\n        }\n      }\n    }\n    space {\n      id\n      frame\n      position\n      configuration\n      hub {\n        id\n        status\n        meta {\n          id\n          name\n          services\n          street\n          city\n          postalCode\n        }\n      }\n    }\n  }\n}\n\nfragment MyLocksTabsFragment on UtilizationGrant {\n  id\n  deactivatedAt\n  reservation {\n    id\n    deactivatedAt\n    contentNote\n    note\n    subtype {\n      __typename\n      ... on B2BlockReservationSubtype {\n        createdByUserId {\n          id\n        }\n      }\n      ... on B2ClockReservationSubtype {\n        user {\n          id\n        }\n      }\n    }\n    space {\n      id\n      frame\n      position\n      hub {\n        id\n        meta {\n          name\n          services\n          lat\n          lng\n        }\n      }\n    }\n  }\n  ...LockCardFragment\n}\n"
  }
};
})();

(node as any).hash = "069527677ca0e88759bf68e14ff3caf6";

export default node;
